import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";


@Component({
    selector: 'app-receivedate-wise-emidetail',
    templateUrl: './receivedate-wise-emidetail.component.html',
    styleUrls: ['./receivedate-wise-emidetail.component.scss'],
    standalone: false
})
export class ReceivedateWiseEmidetailComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  currentUser: any;
  DueFromDate : any;
  DueToDate : any;
  SelectBranch: any[] = [];
  SelectProduct: any[] = [];
  BranchesList: any = [];
  ProductList: any = [];

  branchSettings = {
  singleSelection: false,
  idField: 'BranchId',
  textField: 'Branch_Name',
  selectAllText: 'Select All',
  unSelectAllText: 'Deselect All',
  allowSearchFilter: true,
  itemsShowLimit: 1,
};

  productSettings = {
    singleSelection: false,
    idField: 'ProductId',
    textField: 'Product',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    allowSearchFilter: true,
    itemsShowLimit: 1,
  };

  // DueFromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  // DueToDate: any = new Date();
    FyearId: any;
  maxDate: any;
  minDate: any;
  ReceiveFrom :any;
  ReceiveTo:any =  new Date()
  DataSource: MatTableDataSource<any>;
  showSpinner: boolean = false;
  displayedColumns: string[] = [
  '#',
  'Application_No',
  'LoanAcNo',
  'Customer_Name',
  'Customer_PhoneNo',
  'Branch_Name',
  'Product_Name',
  'Total_EMI',
  'EMI_No',
  'Due_Date',
  'EMI_Amount',
  'Total_Received',
  'ReceivedIn_Period',
  'Last_PaidAmount',
  'LastPayment_Date',
  'Remaining_EMIAmount',
  'EMI_Status'
];


  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  configSuccess : MatSnackBarConfig = {
      panelClass: "style-success",
      duration: 5000,
      horizontalPosition: "right",
      verticalPosition: "top",
    };
  constructor(
    private route: ActivatedRoute,
        private dataSharingService: DataSharingService,
        private reportsService: ReportsService,
        private MasterService: MasterService,
        private snackBar: MatSnackBar,
        private lmsService: LmsService
  ) {
   }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Collection Against DUE");
    this.getBranchesList();
    this.getProductDropdown();
    // this.lmsService
    //     .Get_FinancialYear({ Id: this.FyearId })
    //     .subscribe((res: any) => {
    //       this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
    //       this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
    //       this.DueFromDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
    //       if (this.maxDate > new Date() && this.minDate < new Date())
    //         this.DueToDate = new Date();
    //       else this.DueToDate = this.maxDate;
    //       this.DataSource = null;
    //     });
  }

    getProductDropdown() {
    this.MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
      });
  }
  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
  if (!items?.length) {
    return [];
  }

  const selectedIds = new Set(
    (selectedItems || []).map((item: any) => String(item[key]))
  );

  const selected = items.filter((item: any) => selectedIds.has(String(item[key])));
  const unselected = items.filter((item: any) => !selectedIds.has(String(item[key])));

  return [...selected, ...unselected];
}

onBranchSelectionChange(selectedItems: any[]) {
  this.SelectBranch = selectedItems;

  setTimeout(() => {
    this.BranchesList = this.moveSelectedItemsToTop(
      this.BranchesList,
      this.SelectBranch,
      "BranchId"
    );
  }, 0);
}

onProductSelectionChange(selectedItems: any[]) {
  this.SelectProduct = selectedItems;

  setTimeout(() => {
    this.ProductList = this.moveSelectedItemsToTop(
      this.ProductList,
      this.SelectProduct,
      "ProductId"
    );
  }, 0);
}
 applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }

  getSelectedIds(value: any, key: string): string {
    if (Array.isArray(value)) {
      return value.length ? value.map((item) => item[key]).join(",") : "0";
    }

    return value && value !== "" ? value : "0";
  }
                                
  onsearchemidetails(){
    this.showSpinner = true;
   this.reportsService.ReceiveDate_Wise_EMIDetail({
    DueFromDate: moment(this.DueFromDate).format("YYYY-MM-DD"),
    DueToDate: moment(this.DueToDate).format("YYYY-MM-DD"),
    ReceiveFrom: this.ReceiveFrom ? moment(this.ReceiveFrom).format("YYYY-MM-DD") : null,
    ReceiveTo: this.ReceiveTo ? moment(this.ReceiveTo).format("YYYY-MM-DD") : null,
    BranchId: this.getSelectedIds(this.SelectBranch, "BranchId"),
    ProductId: this.getSelectedIds(this.SelectProduct, "ProductId"),
    LoginUserId: this.currentUser.userId
  }).subscribe((res:any)=>{
    if(res.length == 0){
      this.showSpinner = false;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No Data Found",
        ...this.configSuccess,
      });
      this.DataSource = null;
      return;
    }else{
    this.showSpinner = false;
    console.log("res", res)
    this.DataSource = new MatTableDataSource(res);
    this.DataSource.paginator = this.paginator;
    this.DataSource.sort = this.sort;

  }
  }); 
}
    exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `collection-against-due`,
      sheet: "collection-against-due",
    });
  }
}
  
